export enum ETab {
  CarbonFootprint = 'Carbon Footprint',
  CarbonSavings = 'Carbon Savings',
}
